import { AppConnectMasterRaw } from "@/domain/AppConnectMasters";
import React, { useMemo, ReactNode, createContext, useContext } from "react";
import { useAPI } from "../hooks";

const appConnectMastersCtx = createContext<{
  appConnectMasters: AppConnectMasterRaw[] | null;
  runReloadAppConnectMasters: () => Promise<void>;
  isLoadedAppConnectMasters: boolean;
}>({
  appConnectMasters: [],
  runReloadAppConnectMasters: async () => {
    // nop
  },
  isLoadedAppConnectMasters: false,
});

// 組織ごとに利用可能なAppConnectMasterを提供するプロバイダ
export const AppConnectMastersProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const {
    state: appConnectMasters,
    runReloadState: runReloadAppConnectMasters,
    isLoadedState: isLoadedAppConnectMasters,
  } = useAPI<AppConnectMasterRaw[]>("connect_masters_owned");

  const appConnectMastersCtxValue = useMemo(
    () => ({
      appConnectMasters,
      isLoadedAppConnectMasters,
      runReloadAppConnectMasters,
    }),
    [appConnectMasters, isLoadedAppConnectMasters, runReloadAppConnectMasters]
  );

  return (
    <appConnectMastersCtx.Provider value={appConnectMastersCtxValue}>
      {children}
    </appConnectMastersCtx.Provider>
  );
};

export const useAppConnectMasters = () => {
  return useContext(appConnectMastersCtx);
};
